import React from 'react';
import WizardTable from "./wizardTable";
import FormResponseMessage from "../../formResponseMessage";

const Step4 = (props) => {
    if (props.currentStep !== 4)
        return null;
    return (
        <div>
            <p className="premiumSettingsWizard-step-message">{props.stepMessage}</p>
            <WizardTable
                isEditMode={props.isEditMode}
                handleRecoverableAndNonRecoverableChange={props.handleRecoverableAndNonRecoverableChange}
                selectedCaseType={props.selectedCaseType}
                selectedSubCaseType={props.selectedSubCaseType}
                getSolicitor={props.getSolicitor}
                tableData={props.tableData}
                getAgentIndex={props.getAgentIndex}
                getTableIndex={props.getTableIndex}
                handleCommissionChange={props.handleCommissionChange}
                handlePremiumAndUnderwriterChange={props.handlePremiumAndUnderwriterChange}
                damageBands={props.damageBands}
                selectedCaseStages={props.selectedCaseStages}
                solicitorsList={props.solicitorsList}
                getTableHeaderData={props.getTableHeaderData}
            />
            {
                props.validationMessage !== '' ?
                    <FormResponseMessage
                        LeftWrapper=""
                        CenterWrapper="col-sm-12"
                        MessageStyle="formResponseMessage-reject"
                        Message={props.validationMessage}
                    />
                    :
                    null
            }
        </div>
    )
};

export default Step4;